module.exports = __webpack_public_path__ + "static/media/Sample_Outline.fa036bdd.png";